import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = ({ onLogout, onToggleSidebar }) => {
  const navigate = useNavigate();
  
  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleProfileClick = () => {
    navigate('/perfil');
    setIsOpen(false);
  };

  const handleLogoutClick = () => {
    setIsOpen(false);
    handleLogout();
  };

  return (
    <header className="header">
      <div className="header-content" style={{ 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        position: 'relative',
        padding: '0 20px',
        boxSizing: 'border-box'
      }}>
        <div style={{ 
          position: 'absolute',
          left: '0',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 1,
          margin: '0 0 0 10px'
        }}>
          <button 
            onClick={onToggleSidebar}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '1.5rem',
              cursor: 'pointer',
              padding: '8px',
              borderRadius: '4px',
              transition: 'background-color 0.2s',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '40px',
              height: '40px'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'}
            onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            ☰
          </button>
        </div>
        
        <div className="header-title" style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          pointerEvents: 'none'
        }}>
          <span className="blossom-text">Blossom</span>
          <span className="tagline">Estamos para atenderte</span>
        </div>
        <div className="user-menu" ref={dropdownRef}>
          <div className="user-avatar" onClick={toggleDropdown}>
            <span className="user-initial">U</span>
          </div>
          {isOpen && (
            <div className="dropdown-menu">
              <div className="dropdown-item" onClick={handleProfileClick}>
                <i className="fas fa-user"></i>
                <span>Usuario</span>
              </div>
              <div className="dropdown-divider"></div>
              <div className="dropdown-item" onClick={handleLogoutClick}>
                <i className="fas fa-sign-out-alt"></i>
                <span>Cerrar Sesión</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
